import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";

import Button from "../UI/Button";
import CustomSelect from "../UI/CustomSelect";
import DateRangePicker from "../UI/DateRangePicker";
import Label from "../UI/Label";
import Input from "../UI/Input";
import { getAxios } from "../../Services/commonService";
import { API_GET_SERVERS } from "../../utils/api/ApiConstant";

const ScriptPositionHistoryFilter = ({ rowData, handleFilterChange }) => {
  // 7 days ago from today
  const daysAgo = useMemo(() => {
    let d = new Date();
    d.setDate(d.getDate() - Math.abs(7));
    return d;
  }, []);

  const { isLoading: serverListLoading, data: serverList } = useQuery({
    queryKey: ["serverList"],
    queryFn: async () => {
      const res = await getAxios({ url: API_GET_SERVERS, params: {} });
      return res || [];
    },
  });

  const serverOptions = useMemo(() => {
    if (!serverList) return [];

    const filteredList = serverList.sort((a, b) => a.localeCompare(b));

    return filteredList.map((server) => ({
      label: server,
      value: server,
    }));
  }, [serverList]);

  const { values, handleSubmit, resetForm, setFieldValue } = useFormik({
    initialValues: {
      startDate: daysAgo,
      endDate: new Date(),
      server: { label: "All", value: "All" },
    },
    onSubmit: (value) => {
      const payload = {
        server: value.server?.value,
        fromDate: value.startDate,
        toDate: value.endDate,
        scriptToken: rowData?.ScriptToken,
      };
      handleFilterChange({ filterData: payload });
    },
  });

  return (
    <form className="date-input-main" onSubmit={handleSubmit}>
      <div className="row m-0 p-0 align-items-end">
        <div className="col-lg-2 col-6 m-0 p-1">
          <div className="date-input-box">
            <Label htmlFor="" className="lead_text">
              Script
            </Label>
            <Input
              type="text"
              value={rowData?.Script}
              className="form-control"
              disabled={true}
            />
          </div>
        </div>

        <div className="col-lg-2 col-6 m-0 p-1">
          <div className="date-input-box">
            <Label htmlFor="" className="lead_text">
              Servers
            </Label>
            <CustomSelect
              className="dropdown-control "
              options={serverOptions}
              onChange={(selectedOption) => {
                setFieldValue("server", selectedOption);
              }}
              value={values.server}
              name="server"
              id="server"
              isClearable={false}
            />
          </div>
        </div>

        <DateRangePicker
          values={values}
          setFieldValue={setFieldValue}
          className="date-input-box"
          customClass="col-lg-2 col-12 m-0 p-1 "
          showTimeSelect={false}
          startDatePlaceholder="select start date"
          endDatePlaceholder="select end date"
          dateFormat="dd-MM-yyyy"
          maxDate=""
        />

        <div className="col-lg-1 col-6 m-0 p-1">
          <Button
            type="submit"
            className="ban-man-box history-btn"
            title="View"
          >
            View
          </Button>
        </div>
        <div className="col-lg-1 col-6 m-0 p-1">
          <Button
            type="button"
            className="ban-man-box clear-btn"
            title="Clear"
            onClick={() => resetForm()}
          >
            Clear
          </Button>
        </div>
      </div>
    </form>
  );
};

export default ScriptPositionHistoryFilter;
